export const validatePeriod = (startDate: Date, endDate: Date) => {
    if (!startDate || !endDate) {
        throw new Error('Vul een start en/of einddatum in');
    }
};
